<app-link [iconEnd]="showIcon ? '@tui.download' : ''" [pseudo]="pseudo" (click)="openLink()">
  <ng-content></ng-content>
</app-link>
